// ==================== COMPONENTE DE LOGIN ====================
// Pantalla de inicio de sesión y registro

import React, { useState } from 'react';
import authService from '../../servicios/authService';
import '../../estilos/Login.css';

function Login({ alIniciarSesion }) {
  const [modoRegistro, setModoRegistro] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [cargando, setCargando] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState('');
  
  // Estados adicionales para registro
  const [nombreProyecto, setNombreProyecto] = useState('');
  const [gerenteProyecto, setGerenteProyecto] = useState('');

  const manejarSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setCargando(true);

    try {
      let resultado;
      
      if (modoRegistro) {
        // Registro
        if (!email || !password || !confirmPassword || !nombreProyecto || !gerenteProyecto) {
          setError('Por favor completa todos los campos');
          setCargando(false);
          return;
        }
        
        if (password !== confirmPassword) {
          setError('Las contraseñas no coinciden');
          setCargando(false);
          return;
        }
        
        if (password.length < 6) {
          setError('La contraseña debe tener al menos 6 caracteres');
          setCargando(false);
          return;
        }
        
        resultado = await authService.registro(email, password, nombreProyecto, gerenteProyecto);
      } else {
        // Login
        if (!email || !password) {
          setError('Por favor ingresa email y contraseña');
          setCargando(false);
          return;
        }
        
        resultado = await authService.login(email, password);

        // Verificar si el login fue exitoso
        if (resultado.error || !resultado.token) {
          throw new Error(resultado.mensaje || 'Error al iniciar sesión');
        }
      }

      // Si fue exitoso, notificar al componente padre
      if (resultado.token) {
        alIniciarSesion(resultado);
      }
    } catch (err) {
      console.error('Error en autenticación:', err);
      const mensajeError = err.mensaje || err.error || err.message || 'Error al autenticar';
      setError(mensajeError);
    } finally {
      setCargando(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-logo">
          <img
            src="/logo.png"
            alt="GestraCOO"
            style={{ width: '90px', height: '90px', objectFit: 'contain', marginBottom: '4px' }}
          />
          <div className="login-logo-box" style={{
            fontSize: '28px',
            fontWeight: '800',
            letterSpacing: '-1px',
          }}>
            Gestra<span style={{ color: '#111827' }}>COO</span>
          </div>
        </div>
        
        <h1 className="login-title">
          {modoRegistro ? 'Crear Cuenta' : 'Iniciar Sesión'}
        </h1>
        
        <p className="login-subtitle">
          Plataforma de Gestión y Control de Proyectos de Construcción
        </p>

        <form onSubmit={manejarSubmit} className="login-form">
          {modoRegistro && (
            <>
              <div className="form-group">
                <label htmlFor="nombreProyecto">
                  Nombre del Proyecto
                </label>
                <input
                  id="nombreProyecto"
                  type="text"
                  value={nombreProyecto}
                  onChange={(e) => setNombreProyecto(e.target.value)}
                  placeholder="Ej: Proyecto Plaza Central"
                  disabled={cargando}
                  autoComplete="organization"
                  required={modoRegistro}
                />
              </div>

              <div className="form-group">
                <label htmlFor="gerenteProyecto">
                  Empresa Constructora
                </label>
                <input
                  id="gerenteProyecto"
                  type="text"
                  value={gerenteProyecto}
                  onChange={(e) => setGerenteProyecto(e.target.value)}
                  placeholder="Nombre de la empresa constructora"
                  disabled={cargando}
                  autoComplete="organization"
                  required={modoRegistro}
                />
              </div>
            </>
          )}
          
          <div className="form-group">
            <label htmlFor="email">
              Email
            </label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value.trim().toLowerCase())}
              placeholder="tu@email.com"
              disabled={cargando}
              autoComplete="email"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">
              Contraseña
            </label>
            <div className="password-input-container">
              <input
                id="password"
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder={modoRegistro ? 'Mínimo 6 caracteres' : 'Tu contraseña'}
                disabled={cargando}
                autoComplete={modoRegistro ? 'new-password' : 'current-password'}
                minLength={6}
                required
              />
              <button
                type="button"
                className="password-toggle-btn"
                onClick={() => setShowPassword(!showPassword)}
                disabled={cargando}
                title={showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'}
              >
                {showPassword ? 'Ocultar' : 'Mostrar'}
              </button>
            </div>
          </div>

          {modoRegistro && (
            <div className="form-group">
              <label htmlFor="confirmPassword">
                Confirmar Contraseña
              </label>
              <div className="password-input-container">
                <input
                  id="confirmPassword"
                  type={showPassword ? 'text' : 'password'}
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  placeholder="Repite tu contraseña"
                  disabled={cargando}
                  autoComplete="new-password"
                  minLength={6}
                  required={modoRegistro}
                />
                <button
                  type="button"
                  className="password-toggle-btn"
                  onClick={() => setShowPassword(!showPassword)}
                  disabled={cargando}
                  title={showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'}
                >
                  {showPassword ? 'Ocultar' : 'Mostrar'}
                </button>
              </div>
            </div>
          )}

          {error && (
            <div className="error-message">
              {error}
            </div>
          )}

          <button
            type="submit"
            className="login-button"
            disabled={cargando}
          >
            {cargando ? (
              <span>
                <span className="spinner"></span> Cargando...
              </span>
            ) : (
              modoRegistro ? 'Crear Cuenta' : 'Iniciar Sesión'
            )}
          </button>
        </form>

        <div className="login-footer">
          <button
            type="button"
            className="toggle-mode-button"
            onClick={() => {
              setModoRegistro(!modoRegistro);
              setError('');
              setEmail('');
              setPassword('');
              setNombreProyecto('');
              setGerenteProyecto('');
            }}
            disabled={cargando}
          >
            {modoRegistro
              ? '¿Ya tienes cuenta? Inicia sesión aquí'
              : '¿No tienes cuenta? Regístrate aquí'}
          </button>
        </div>

        <div className="login-info">
          <p><strong>Primera vez:</strong></p>
          <p>Crea una cuenta para comenzar a gestionar tus proyectos de forma profesional</p>
        </div>
      </div>
    </div>
  );
}

export default Login;
